var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBox",
    {
      staticClass: "job__job-runs overflow-hidden h-100",
      attrs: { direction: "column" }
    },
    [
      _vm.item.runs && _vm.item.runs.length === 1
        ? _c("JobRunView", { attrs: { item: _vm.item.runs[0] } })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.runs && _vm.item.runs.length > 1
        ? _c(
            "BCard",
            { staticClass: "overflow-hidden", attrs: { "no-body": "" } },
            [
              _vm.item.runs && _vm.item.runs.length
                ? _c(
                    "BTabs",
                    { attrs: { card: "" } },
                    _vm._l(_vm.item.runs, function(run) {
                      return _c(
                        "BTab",
                        { key: run.id, staticClass: "overflow-hidden h-100" },
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            [
                              _c("ItpText", {
                                attrs: { text: "#" + run.run_number }
                              }),
                              _vm._v(" "),
                              _c("UcStatusBadge", {
                                attrs: { status: run.status }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("JobRunView", { attrs: { item: run } })
                        ],
                        2
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }